import type { SVGProps } from "react";
import * as React from "react";
const SvgListOrdered2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.75 4.5H4.717l-1.467.393v1.553l1-.268V9.5H3V11h4V9.5H5.75v-5ZM10 5h11v2H10V5Zm0 6h11v2H10v-2Zm0 6h11v2H10v-2Zm-7.125-2.375a2.125 2.125 0 1 1 3.812 1.292l-.004.006L5.316 17.5H7V19H3v-1.121l2.472-2.844a.625.625 0 1 0-1.094-.466l-.013.306h-1.49v-.25Z"
    />
  </svg>
);
export default SvgListOrdered2;
